import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { useLplModel } from "../lplModel";
import { ColumnsType } from "antd/lib/table";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";
import { IEnquiryDetail } from "@/views/inquires/enquiry/enquiryTypes";
import moment from "moment";


export const InquireDialog = () => {
    const { inquireDialog: { visible, codes }, setDialog } = useLplModel(({ inquireDialog }) => [inquireDialog])
    //列表数据源
    const [dataSource, setDataSource] = useState<IEnquiryDetail[]>([]);
    const [loading, setLoadding] = useState<boolean>(false);

    useEffect(() => {
        if (visible) {
            loadData()
        } else {
            setDataSource([])
        }
    }, [visible])

    const getOrderOne = async (code: string) => {
        try {
            let { retData } = await enquiryService.one(code);
            return retData
        } catch {
            return null
        }
    }

    const loadData = async () => {
        // setLoadding(true)
        if (!codes) return
        const tempArr = codes.split(",");
        const newArr = [];
        for (let i = 0; i < tempArr.length; i++) {
            let res = await getOrderOne(tempArr[i]);
            res && newArr.push(res)
        }
        setDataSource(newArr)
        // setLoadding(false)
    }

    const onCancel = () => {
        setDialog("inquire", false);
    };


    const column: ColumnsType<any> = [
        {
            title: '序号',
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '询价单号',
            dataIndex: 'realCode',
        }, {
            title: '询价日期',
            dataIndex: 'createTime',
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }
    ];


    return <YHModal
        visible={visible}
        onOk={onCancel}
        onCancel={onCancel}
        title="询价详情"
        width={600}
        bodyHeight={400}
        showFooter={true}
    >
        <YhBox title=" " style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                rowKey={record => record.id}
                loading={loading}
                columns={column}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    </YHModal>
}